module.exports = __webpack_public_path__ + "img/stopdropandtype.73b6cde3.png";